
/* injects from baggage-loader */

const moduleSlider = angular.module('timer.initializer', []);

moduleSlider.service('Timer', [
  '$timeout', '$injector', 'ns', '$translate',
  ($timeout, $injector, ns, $translate) => {
    'use strict';
    let Y = void 0;

    const timer = {
      init: function(y) {
        Y = y;
        this.initTimers();
      },
      resizers: [],
      findTimers: function() {
        const layoutEditor = $injector.get('layoutEditor');

        this.timers = $('.str-block .strbw-timer');
      },
      initTimer: function(index, timer, data) {
        let settings;

        if (data === null) {
          data = false;
        }

        if (data) {
          settings = angular.copy(data);
        } else {
          settings = $(timer).data('settings');
        }

        const clock = $(timer).FlipClock({
          clockFace: 'DailyCounter',
          autoStart: false,
          language: $translate.use()
        });
        clock.setCountdown(true);

        if (settings.is_started) {
          clock.start();
        }

        if (settings) {
          this.updateLabel(clock.$wrapper, '.flip-clock-divider.days .flip-clock-label', settings.days_label);
          this.updateLabel(clock.$wrapper, '.flip-clock-divider.hours .flip-clock-label', settings.hours_label);
          this.updateLabel(clock.$wrapper, '.flip-clock-divider.minutes .flip-clock-label', settings.minutes_label);
          this.updateLabel(clock.$wrapper, '.flip-clock-divider.seconds .flip-clock-label', settings.seconds_label);
        }

        $(timer).find('a').attr('href', 'javascript: void(0)');
      },
      initTimers: function() {
        this.findTimers();
        this.timers.each(this.initTimer.bind(this));
      },
      updateLabel: function($wrapper, selector, text) {
        const $label = $wrapper.find(selector);
        if (text !== undefined && $label.length > 0) {
          $label.text(text);
        }
      },
      destroy: function() {}
    };

    return timer;
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/timer/timer.initializer.js